import { EMPTY_ARRAY } from "../misc";

import { getKpiResultsAndProviders } from "./getCountKpisForProviders";
import { KpiReport } from "../processors";

export const getCountFirstKpiAndOneAtLeastForProviders = async (
    kpis?: string[][],
    locationAdminIds?: string[]
): Promise<number> => {
    const firstKpi = kpis?.[0]?.[0];
    const restKpi = kpis
        ?.filter((__, index) => index !== 0)
        ?.map(d => d?.[0])
        ?.filter(d => d != null);

    if (firstKpi == null || !restKpi?.length) return 0;

    const { results } = await getKpiResultsAndProviders(kpis, locationAdminIds);
    const restKpiMap = restKpi?.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const firstKpiResult = results?.find(d => d.kpiCode === firstKpi);
    const restKpiResults = results?.filter(d => restKpiMap[d.kpiCode] === 1) ?? (EMPTY_ARRAY as KpiReport[]);
    if (!firstKpiResult || !restKpiResults?.length) return 0;

    return results.filter(d => d.value != null || d.valueStatus != null).length;
};
